var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print_",
    "data-name": "print ",
    transform: "translate(-489.512 -313.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17147",
    "data-name": "Rectangle 17147",
    width: 16,
    height: 14,
    transform: "translate(499.512 314.049)",
    fill: "#fff",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7194",
    "data-name": "Path 7194",
    d: "M5,0H30a5,5,0,0,1,5,5V16H0V5A5,5,0,0,1,5,0Z",
    transform: "translate(490.512 322.049)",
    fill: "#fff",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    transform: "translate(493.012 326.049)",
    fill: "#053f7f",
    stroke: "#053f7f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17146",
    "data-name": "Rectangle 17146",
    width: 16,
    height: 11,
    transform: "translate(499.512 333.049)",
    fill: "#fff",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63750",
    "data-name": "Line 63750",
    x2: 23,
    transform: "translate(496.512 333.049)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63751",
    "data-name": "Line 63751",
    x2: 10.615,
    transform: "translate(502.512 337.049)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63752",
    "data-name": "Line 63752",
    x2: 10.615,
    transform: "translate(502.512 340.549)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.3ca99a256080bc750c860e356b54bf0d.svg";
export { ForwardRef as ReactComponent };